import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DishServices } from "../../../services";
import { DishCreatePricePage } from "../../dish-create-price/dish-create-price";
import { Globals } from '../../../../../globals';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-preparation',
    templateUrl: 'dish-preparation.html',
})
export class DishPreparationPage {
    update_state: boolean = false;
    dish_uid: any;
    recipe: string = '';
    tools: string = '';
    time: string = '';
    dish_name: string;
    dish: any;
    time_cooking: string = '';
    difficulty: string = '';
    //
    _recipe: string = '';
    _tools: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        public translate: TranslateService) {

        this.update_state = this.navParams.get('update');
        this.dish_uid = this.navParams.get('dish_uid');
        this.dish_name = this.navParams.get('dish_name');
        this.dish = this.navParams.get('dish');

        if (this.update_state) {
            this.recipe = this.navParams.get('recipe');
            this.tools = this.navParams.get('tools');
            this.time = this.navParams.get('time');
            this._recipe = this.navParams.get('recipe');
            this._tools = this.navParams.get('tools');
            this.time_cooking = this.navParams.get('time_cooking');
            this.difficulty = this.navParams.get('difficulty');
        }
    }

    getInitRecipe(editor: any) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.recipe = editor.html;
            } else {
                this.recipe = '';
            }
        }
    }

    getInitTools(editor: any) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.tools = editor.html;
            } else {
                this.tools = '';
            }
        }
    }

    update() {
        if (!this.recipe) {
            this.recipe = '';
        }
        if (!this.tools) {
            this.tools = '';
        }
        if (!this.time) {
            this.time = '';
        }

        if (!this.time_cooking) {
            this.time_cooking = '';
        }

        if (!this.difficulty) {
            this.difficulty = '';
        }

        this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
            'recipe': this.recipe,
            'time': this.time,
            'tools': this.tools,
            'time_cooking': this.time_cooking,
            'difficulty': this.difficulty,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            if (this.update_state) {
                this.globals.GAtrackView('Dish', 'Dish - Preparation - Update', this.globals.restaurant.email, 'Create/Update', 'Update preparation', 'Dish', this.dish_name);
                this.navCtrl.pop();
            } else {
                this.globals.GAtrackView('Dish', 'Dish - Preparation - Create', this.globals.restaurant.email, 'Create/Update', 'Create preparation', 'Dish', this.dish_name);
                this.navCtrl.push(DishCreatePricePage, {
                    update: this.update_state,
                    dish_uid: this.dish_uid,
                    dish_name: this.dish_name,
                })
            }
        });
    }



}


// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-cost/dish-preparation/dish-preparation.ts